<template>
  <div>
    <div class="notice">
      <img src="@/assets/notice-icon.png" />
      <div>
        嗨支付提醒您，诈骗猖獗，官方不会对用户进行以下行为:私下联系、要求转账、要求提供帐密 &nbsp; 请认明官方Telegram帐号为
        <span><b>@hihipay888</b> (是三个8哦!)</span>
      </div>
    </div>
    <Footer />
    <div class="copyright">Copyright © 2019{{curYear}} hipay Inc.   嗨支付 版权所有</div>
  </div>
</template>

<script>
import Footer from '@/components/footer.vue'
export default {
  components: {
    Footer
  },
  computed: {
    curYear () {
      let nowDate = new Date()
      let year = new Date(nowDate).getFullYear()
      return year === 2019 ? '' : `~${year}`
    }
  }
}
</script>

<style lang="less">
  .notice {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50px;
    font-size: 15px;
    line-height: 1.2;
    font-weight: bold;
    text-align: left;
    color: #000A7A;
    padding: 5px 10px;
    background: #FAD402;
    img {
      width: 40px;
      height: 40px;
      margin-right: 20px;
    }
    div {
      display: flow-root;
      font-size: 15px;
      span {
        font-size: 16px;
        color: #D0021C;
        b {font-size: 22px;}
      }
    }
  }
  .copyright{
    background: #000250;
    color: #FFF;
    font-size: 1em;
    text-align: center;
    padding: .8em;
  }

  @media screen and (min-width: 768px) and (max-width: 1050px) {
    .notice {
      min-height: 2.5em;
      font-size: 1em;
      padding: 0.5em;
      img {
        width: 2em;
        height: 2em;
        margin-right: 1em;
      }
      div {
        font-size: 0.9em;
        span {
          font-size: 1em;
          b {font-size: 1.375em;}
        }
      }
    }
    .copyright{
      background: #000250;
      color: #FFF;
      font-size: 1em;
      text-align: center;
      padding: .8em;
    }
  }

  @media screen and (max-width: 767.9px) {
    .notice {
      height: 2.5em;
      font-size: 1em;
      img {
        width: 2em;
        height: 2em;
        margin-right: 1em;
      }
      div {
        font-size: 0.9em;
        span {
          font-size: 1em;
          b {font-size: 1.375em;}
        }
      }
    }
    .copyright{
      font-size: .8em;
    }
  }
</style>
